import React, {Component} from 'react'


class PushPreview extends Component{

  render(){
    return(
      <div className="push-notification-preview">
        <p className="push-notification-preview-icon">
          <img src="/assets/images/ic_push_notification.png" alt="" />
          <span>produb &#x2022; now</span>
        </p>
        <p className="push-notification-preview-subject">
          {this.props.subject}
        </p>
        <p>
          {this.props.content}
        </p>
      </div>
    )
  }
}

export default (PushPreview)
